import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { allPass as rAllPass, prop as rProp, piped as rPiped, constant as rConstant } from 'remeda';

import { OrganizationAccessControlModuleEnum, CustomerPermissionActionEnum, CustomerPermissionSubjectEnum, type components } from '@/libs/openapi/schema';
import { hasPermissions, hasModule } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
  organization: components['schemas']['OrganizationResponseDto'] | undefined;
}

export const campaignRequestCommentPolicies = definePolicies((ctx: PolicyContext) => ({
  create: rConstant(rAllPass(ctx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST_COMMENT, [
      CustomerPermissionActionEnum.CREATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
}));
